import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getRecentProducts, clearRecentProducts } from '../utils/recentProducts';
import styles from './RecentProductsPage.module.css';
const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8080';

export default function RecentProductsPage() {
    const navigate = useNavigate();
    const [products, setProducts] = useState(getRecentProducts());

    const handleClear = () => {
        clearRecentProducts();
        setProducts([]);
    };

    return (
        <div className={styles.container}>
            <div className={styles.header}>
                <h2>최근 본 상품</h2>
                {products.length > 0 && (
                    <button onClick={handleClear} className={styles.clearBtn}>전체 삭제</button>
                )}
            </div>
            {products.length === 0 ? (
                <p className={styles.empty}>최근 본 상품이 없습니다.</p>
            ) : (
                <div className={styles.grid}>
                    {products.map(p => (
                        <div key={p.productId} className={styles.card} onClick={() => navigate(`/products/${p.productId}`)}>
                            <img src={p.imageUrl ? `${API_URL}${p.imageUrl}` : '/no-image.png'} alt={p.name} className={styles.image} />
                            <div className={styles.info}>
                                <p className={styles.name}>{p.name}</p>
                                {p.discountRate > 0 && (
                                    <p className={styles.original}>{p.originalPrice?.toLocaleString()}원</p>
                                )}
                                <p className={styles.price}>{p.price?.toLocaleString()}원</p>
                            </div>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
}